import axios from '@/utils/request';

// 获取话题列表
export const getTopics = (data: any) => {
  return axios.request({
    url: 'Topic/GetTopics',
    method: 'GET',
    params: data,
  });
};

// 获取我的话题列表
export const getMyTopics = (data: any) => {
  return axios.request({
    url: 'Topic/GetMyTopics',
    method: 'GET',
    params: data,
  });
};

export const getTopicClassList =(data:any) =>{
  return axios.request({
    url:'Topic/GetTopicClassList',
    method:'GET',
    params:data,
  });
};
// 更新封面图
export const updateCover = (data: any) => {
  return axios.request({
    url: 'Topic/UpdateCover',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

// 获取话题详情
export const getTopicDetails = (data: any) => {
  return axios.request({
    url: 'Topic/GetTopicQuestionDetails',
    method: 'GET',
    params: data,
  });
};

// 获取我的话题详情
export const getMyTopicDetails = (data: any) => {
  return axios.request({
    url: 'Topic/GetMyTopicQuestionDetails',
    method: 'GET',
    params: data,
  });
};

// 获取相关话题
export const getRelatedTopics = (data: any) => {
  return axios.request({
    url: 'Topic/GetRelatedTopics',
    method: 'GET',
    params: data,
  });
};

// 获取话题回答列表
export const getTopicAnswers = (data: any) => {
  return axios.request({
    url: 'Topic/GetTopicAnswers',
    method: 'GET',
    params: data,
  });
};

// 获取话题回答详情
export const getTopicAnswerDetails = (data: any) => {
  return axios.request({
    url: 'Topic/GetTopicAnswerDetails',
    method: 'GET',
    params: data,
  });
};

// 话题组回答有图片
export const submitAnswerFile = (data: any) => {
  return axios.request({
    url: 'Topic/SubmitAnswerFile',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

// 话题组回答
export const submitAnswer = (data: any) => {
  return axios.request({
    url: 'Topic/SubmitAnswer',
    method: 'POST',
    data,
  });
};

// 删除话题回答
export const deleteTopicAnswer = (data: any) => {
  return axios.request({
    url: 'Topic/DeleteTopicAnswer',
    method: 'POST',
    data,
  });
};

// 点赞/取消点赞
export const likesOrCancelTopicAnswer = (data: any) => {
  const config: any = {
    url: 'Topic/LikesOrCancelTopicAnswer',
    method: 'POST',
    params: data,
    showLoading: false,
  };
  return axios.request(config);
};

// 获取话题回复列表
export const getTopicReplys = (data: any) => {
  return axios.request({
    url: 'Topic/GetTopicReplys',
    method: 'GET',
    params: data,
  });
};

// 话题组回复
export const submitReply = (data: any) => {
  return axios.request({
    url: 'Topic/SubmitReply',
    method: 'POST',
    data,
  });
};

// 话题回复删除
export const delReply = (data: any) => {
  return axios.request({
    url: 'Topic/DelReply',
    method: 'POST',
    params: data,
  });
};


// 获取我的话题列表
export const getMyTopic = (data: any) => {
  return axios.request({
    url: 'Topic/GetMyTopic',
    method: 'GET',
    params: data,
  });
};

// 获取我的话题列表
export const getMyTopicDetail = (data: any) => {
  return axios.request({
    url: 'Topic/GetMyTopicDetail',
    method: 'GET',
    params: data,
  });
};

// 新增&编辑我的话题
export const postMyTopic = (data: any) => {
  return axios.request({
    url: 'Topic/PostMyTopic',
    method: 'POST',
    data,
  });
};

// 删除我的话题
export const deleteMyTopic = (data: any) => {
  return axios.request({
    url: 'Topic/DeleteMyTopic',
    method: 'POST',
    data,
  });
};
